export default __webpack_public_path__ + "static/media/TH-55JX600 2.56d1e7fb.jpg";